const translations = {
    actionsLabel: 'User actions',
    active: 'Active',
    allCertificationStatuses: 'All certification statuses',
    certificationStatusFilterLabel: 'Certification status',
    certifications: 'Certifications',
    email: 'Email',
    emptyDescription: 'Invite a teammate to see them listed here.',
    emptyHeading: 'No users yet',
    expiredCertifications: 'Expired',
    expiringCertifications: 'Expiring within {{dayCount}} days',
    inactive: 'Inactive',
    loadError: 'Users could not be loaded.',
    loadMore: 'Load more',
    manage: 'Manage',
    name: 'Name',
    noCertifications: 'No certifications',
    noMatchesDescription: 'Pick a different certification status to see more users.',
    noMatchesHeading: 'No users match this filter',
    role: 'Role',
    status: 'Status',
    tableLabel: 'Users'
};

export default translations;
